const BASE = "/risk-scoring/compositor";

export const riskScoringCompositorEndpoints = {
  config: () => `${BASE}/config`,
  configHistory: () => `${BASE}/config/history`,
} as const;
